/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_New_Networks_TitleInputs */

const fr_help_new_networks_title = /** @type {(inputs: Help_New_Networks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Nouveaux réseaux`)
};

const en_help_new_networks_title = /** @type {(inputs: Help_New_Networks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. New networks`)
};

/**
* | output |
* | --- |
* | "4. New networks" |
*
* @param {Help_New_Networks_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_new_networks_title = /** @type {((inputs?: Help_New_Networks_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_New_Networks_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_new_networks_title(inputs)
	return en_help_new_networks_title(inputs)
});